import {type ThemeOptions} from '@mui/material/styles';

export const ThemeBase: ThemeOptions = {
  spacing: 10,
  components: {
    MuiButton: {
      defaultProps: {size: 'medium', color: 'primary'},
      styleOverrides: {
        root: {textTransform: 'none', whiteSpace: 'nowrap', borderRadius: 8},
        sizeMedium: {fontSize: 16},
      },
    },
    MuiChip: {styleOverrides: {root: {borderRadius: 8}}},
    MuiToggleButton: {styleOverrides: {root: {textTransform: 'none'}}},
    MuiOutlinedInput: {styleOverrides: {root: {borderRadius: 8}}},
    MuiDialogContent: {styleOverrides: {root: {overflowX: 'hidden'}}},
  },
  typography: {
    fontFamily:
      'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 13,
  },
  shape: {borderRadius: 16},
};
